import { render, staticRenderFns } from "./horizontal-navbar.vue?vue&type=template&id=444aad0a&"
import script from "./horizontal-navbar.vue?vue&type=script&lang=js&"
export * from "./horizontal-navbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports